// @ts-nocheck
import styled from "@emotion/styled";
import { useContext, useEffect, useState } from "react";
import axios from "axios";
import { ThemeContext } from "theme/themeContext";
import { switchComponent } from "theme/switch";
import { ReactComponent as ActivityDark } from "../../assets/svg/activityDark.svg";
import { ReactComponent as ActivityLight } from "../../assets/svg/activityLight.svg";
import { ReactComponent as RecordDark } from "../../assets/svg/recordDark.svg";
import { ReactComponent as RecordLight } from "../../assets/svg/recordLight.svg";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  BarElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import { SwitchLock } from "components/Toggle/Toggle";
import { useTheme } from "@emotion/react";
import { DefaultLayout } from "layouts/DefaultLayout";
import { LoaderContainer } from "Routes";
import { Loader } from "components/Loader/Loader";
import parse from "html-react-parser";
import { useParams, useSearchParams } from "react-router-dom";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  BarElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  interaction: {
    mode: "index" as const,
    intersect: false,
  },
  stacked: false,
  aspectRatio: 1,
  scales: {
    y: {
      type: "linear" as const,
      display: true,
      position: "left" as const,
    },
    y1: {
      type: "linear" as const,
      display: true,
      position: "right" as const,
      grid: {
        display: false,
        drawBorder: false,
      },
    },
  },
};

const Container = styled.div(({ theme }) => ({
  backgroundColor: theme.switch(
    theme.colors.dark.background,
    theme.colors.light.background
  ),
  color: theme.switch(theme.colors.dark.font, theme.colors.light.font),
  boxSizing: "border-box",
  padding: "35px",
  display: "flex",
  gap: "25px",
  "& a": {
    color: "#0B509F",
    textDecoration: "none",
  },
}));

const LeftContent = styled.div(() => ({
  width: "70%",
}));

const RightContent = styled.div(() => ({
  width: "30%",
}));

const NameBlock = styled.div(({ theme }) => ({
  width: "100%",
  padding: "25px",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: "10px",
  background: theme.switch(theme.colors.dark.main, theme.colors.light.main),
  boxShadow: theme.switch(
    0,
    "0px 0px 0px 0px rgba(207, 207, 207, 0.10), 0px 4px 9px 0px rgba(207, 207, 207, 0.10), 0px 17px 17px 0px rgba(207, 207, 207, 0.09), 0px 37px 22px 0px rgba(207, 207, 207, 0.05), 0px 67px 27px 0px rgba(207, 207, 207, 0.01), 0px 104px 29px 0px rgba(207, 207, 207, 0.00)"
  ),
  borderRadius: "10px",
  marginBottom: "20px",
}));

const KeyValues = styled.div(({ theme }) => ({
  width: "100%",
  display: "flex",
  gap: "15px",
  justifyContent: "space-between",
  padding: "25px",
  background: theme.switch(theme.colors.dark.main, theme.colors.light.main),
  boxShadow: theme.switch(
    0,
    "0px 0px 0px 0px rgba(207, 207, 207, 0.10), 0px 4px 9px 0px rgba(207, 207, 207, 0.10), 0px 17px 17px 0px rgba(207, 207, 207, 0.09), 0px 37px 22px 0px rgba(207, 207, 207, 0.05), 0px 67px 27px 0px rgba(207, 207, 207, 0.01), 0px 104px 29px 0px rgba(207, 207, 207, 0.00)"
  ),
  borderRadius: "10px",
}));

const KeyValueItem = styled.div(({ theme }) => ({
  flex: 1,
  padding: "12px",
  borderRadius: "10px",
  background: theme.switch(
    theme.colors.dark.purpleBg,
    theme.colors.light.purpleBg
  ),
  color: theme.switch(
    theme.colors.dark.fontSecondary,
    theme.colors.light.fontSecondary
  ),
}));

const KeyValueRank = styled.div(({ theme }) => ({
  color: theme.switch(theme.colors.dark.purple, theme.colors.light.purple),
  fontSize: "26px",
  fontWeight: "bold",
}));

const MainContent = styled.div(() => ({
  display: "flex",
  justifyContent: "space-between",
  flexWrap: "wrap",
  marginTop: "20px",
  gap: "15px",
}));

const BlockTitle = styled.div(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  color: theme.switch(theme.colors.dark.font, theme.colors.light.font),
  "& svg": {
    filter:
      "invert(41%) sepia(3%) saturate(2938%) hue-rotate(129deg) brightness(99%) contrast(93%)",
  },
}));

const SwitchBlock = styled.div(() => ({
  minHeight: "350px",
}));

const TitleGlobal = styled.div(({ theme }) => ({
  fontSize: "20px",
  fontWeight: "bold",
  color: theme.switch(theme.colors.dark.font, theme.colors.light.font),
}));

const Overview = styled.div(({ theme }) => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  gap: "15px",
  padding: "25px",
  color: theme.switch(
    theme.colors.dark.fontSecondary,
    theme.colors.light.fontSecondary
  ),
  background: theme.switch(theme.colors.dark.main, theme.colors.light.main),
  boxShadow: theme.switch(
    0,
    "0px 0px 0px 0px rgba(207, 207, 207, 0.10), 0px 4px 9px 0px rgba(207, 207, 207, 0.10), 0px 17px 17px 0px rgba(207, 207, 207, 0.09), 0px 37px 22px 0px rgba(207, 207, 207, 0.05), 0px 67px 27px 0px rgba(207, 207, 207, 0.01), 0px 104px 29px 0px rgba(207, 207, 207, 0.00)"
  ),
  borderRadius: "10px",
  marginBottom: "20px",
}));

const Records = styled.div(({ theme }) => ({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  minHeight: "214px",
  gap: "15px",
  justifyContent: "space-between",
  padding: "25px",
  marginBottom: "20px",
  background: theme.switch(theme.colors.dark.main, theme.colors.light.main),
  boxShadow: theme.switch(
    0,
    "0px 0px 0px 0px rgba(207, 207, 207, 0.10), 0px 4px 9px 0px rgba(207, 207, 207, 0.10), 0px 17px 17px 0px rgba(207, 207, 207, 0.09), 0px 37px 22px 0px rgba(207, 207, 207, 0.05), 0px 67px 27px 0px rgba(207, 207, 207, 0.01), 0px 104px 29px 0px rgba(207, 207, 207, 0.00)"
  ),
  borderRadius: "10px",
}));

const KeyValueName = styled.div(() => ({}));

const BlockDesc = styled.div(() => ({}));

const RecordsContainer = styled.div(() => ({
  display: "flex",
  flexDirection: "column",
  maxHeight: "350px",
  overflowY: "scroll",
}));
const ChartBlock = styled.div(() => ({
  height: "100%",
}));

const Toggle = styled.div(({ theme }) => ({
  display: "flex",
  borderRadius: "10px",
  overflow: "hidden",
  background: theme.switch(
    theme.colors.dark.purpleBg,
    theme.colors.light.purpleBg
  ),
  color: theme.switch(
    theme.colors.dark.fontSecondary,
    theme.colors.light.purple
  ),
}));

const ToggleBlockActive = styled.div(({ theme }) => ({
  padding: "8px 30px",
  borderRadius: "10px",
  color: "#fff",
  background: theme.switch(theme.colors.dark.purple, theme.colors.light.purple),
}));

const ToggleBlock = styled.div(({ theme }) => ({
  padding: "8px 30px",
  cursor: "pointer",
}));

const RecordBlock = styled.div(({ theme }) => ({
  padding: "15px",
  borderRadius: "10px",
  marginBottom: "20px",
  background: theme.switch(
    theme.colors.dark.secondary,
    theme.colors.light.secondary
  ),
}));

const RecordTitle = styled.div(({ theme }) => ({
  fontSize: "16px",
  color: theme.switch(theme.colors.dark.font, theme.colors.light.font),
  marginBottom: "10px",
  display: "flex",
  alignItems: "center",
  gap: "6px",
  "& svg": {
    filter:
      "invert(41%) sepia(3%) saturate(2938%) hue-rotate(129deg) brightness(99%) contrast(93%)",
  },
}));

const RecordDesc = styled.div(({ theme }) => ({
  color: theme.switch(
    theme.colors.dark.fontSecondary,
    theme.colors.light.fontSecondary
  ),
}));

const Condition = styled.div(({ theme }) => ({
  borderRadius: "10px",
  padding: "6px",
  background: theme.switch(
    theme.colors.dark.redSecondary,
    theme.colors.light.redSecondary
  ),
  fontSize: "10px",
  color: theme.switch(theme.colors.dark.red, theme.colors.light.red),
}));

const BlockItem = styled.div(({ theme }) => ({
  width: "49%",
  display: "flex",
  flexDirection: "column",
  gap: "15px",
  justifyContent: "space-between",
  padding: "15px",
  background: theme.switch(theme.colors.dark.main, theme.colors.light.main),
  boxShadow: theme.switch(
    0,
    "0px 0px 0px 0px rgba(207, 207, 207, 0.10), 0px 4px 9px 0px rgba(207, 207, 207, 0.10), 0px 17px 17px 0px rgba(207, 207, 207, 0.09), 0px 37px 22px 0px rgba(207, 207, 207, 0.05), 0px 67px 27px 0px rgba(207, 207, 207, 0.01), 0px 104px 29px 0px rgba(207, 207, 207, 0.00)"
  ),
  borderRadius: "10px",
}));

const ActivitySvg = switchComponent(ActivityDark, ActivityLight);
const RecordSvg = switchComponent(RecordDark, RecordLight);

const dataFromArray = (elem) => {
  let datasets;
  datasets = [
    {
      label: "Dataset " + elem.variable,
      data: elem.data,
      backgroundColor: "#467270",
      borderColor: "#467270",
      options: {
        aspectRatio: 2,
      },
    },
  ];

  return {
    labels: elem.labels,
    datasets,
  };
};

export default function Manager() {
  const theme = useTheme();
  console.log(theme);
  let { id } = useParams();
  const context = useContext(ThemeContext);
  console.log(context);
  const [value, setValue] = useState([]);
  const [keyValues, setKeyValues] = useState([]);
  const [details, setDetails] = useState([]);
  const [components, setComponents] = useState([]);
  const [overview, setOverview] = useState("");
  const [loading, setLoading] = useState(true);
  const [loading1, setLoading1] = useState(true);
  const [records, setRecords] = useState([]);
  const [messages, setMessages] = useState([]);

  const getRetailDemo = () => {
    setLoading(true);
    axios
      .get(
        "https://osiris-systems.co.uk/activity/api/apiActivityTracker/?id=" + id
      )
      .then(({ data }) => {
        setKeyValues(data.keyValues);
        setDetails(data.details);
        setOverview(data.overview);
        setComponents(
          data.components.map((x) => {
            return {
              ...x,
              chartToggle: true,
            };
          })
        );
        setLoading(false);
        //@ts-ignore
      })
      .catch((error) => {
        setLoading(false);
        console.log(error);
      });
  };

  const getMessages = () => {
    setLoading1(true);
    axios
      .get(
        "https://osiris-systems.co.uk/activity/api/apiActivityTrackerMessages/?id=" +
          id
      )
      .then(({ data }) => {
        setRecords(data.records);
        setMessages(data.messages);
        setLoading1(false);
        //@ts-ignore
      })
      .catch((error) => {
        setLoading1(false);
        console.log(error);
      });
  };

  useEffect(() => {
    getMessages();
    getRetailDemo();
  }, []);

  if (loading && loading1) {
    return (
      <LoaderContainer>
        <Loader />
      </LoaderContainer>
    );
  }

  return (
    <DefaultLayout>
      <Container>
        <LeftContent>
          <NameBlock>
            <span style={{ display: "flex", gap: "10px" }}>
              {details.name} {details.surname} |{" "}
              {details.conditions &&
                details.conditions.map((elem) => {
                  return <Condition>{elem}</Condition>;
                })}
            </span>
            <SwitchLock
              locked={theme.mode === "light" ? true : false}
              onClick={() => {
                context.toggleTheme();
              }}
            />
          </NameBlock>
          <KeyValues>
            {keyValues.map((elem) => {
              return (
                <KeyValueItem>
                  <KeyValueRank>{elem.value.toFixed(0)}</KeyValueRank>
                  <KeyValueName>{elem.variable}</KeyValueName>
                </KeyValueItem>
              );
            })}
          </KeyValues>
          <MainContent>
            {components.map((x) => {
              return (
                <BlockItem>
                  <BlockTitle>
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                      }}
                    >
                      <ActivitySvg />
                      {x.variable}
                    </span>
                    {x.chartToggle ? (
                      <Toggle>
                        <ToggleBlockActive>Chart</ToggleBlockActive>
                        <ToggleBlock
                          onClick={() => {
                            const newComponents = components.map((elem) => {
                              if (elem.variable != x.variable) {
                                return elem;
                              } else {
                                return {
                                  ...x,
                                  chartToggle: !x.chartToggle,
                                };
                              }
                            });
                            setComponents(newComponents);
                          }}
                        >
                          Analysis
                        </ToggleBlock>
                      </Toggle>
                    ) : (
                      <Toggle>
                        <ToggleBlock
                          onClick={() => {
                            const newComponents = components.map((elem) => {
                              if (elem.variable != x.variable) {
                                return elem;
                              } else {
                                return {
                                  ...x,
                                  chartToggle: !x.chartToggle,
                                };
                              }
                            });
                            setComponents(newComponents);
                          }}
                        >
                          Chart
                        </ToggleBlock>
                        <ToggleBlockActive>Analysis</ToggleBlockActive>
                      </Toggle>
                    )}
                  </BlockTitle>
                  <SwitchBlock>
                    {x.chartToggle ? (
                      <>
                        <ChartBlock>
                          <Bar options={options} data={dataFromArray(x)} />
                        </ChartBlock>
                      </>
                    ) : (
                      <>
                        <RecordBlock>
                          <RecordTitle>Description</RecordTitle>
                          <RecordDesc>{parse(x.text)}</RecordDesc>
                        </RecordBlock>
                      </>
                    )}
                  </SwitchBlock>
                </BlockItem>
              );
            })}
          </MainContent>
        </LeftContent>
        <RightContent>
          <Overview>
            <TitleGlobal>Overview</TitleGlobal>
            <span>{parse(overview)}</span>
          </Overview>
          <Records>
            <TitleGlobal>Messages</TitleGlobal>
            <RecordsContainer>
              {messages.map((elem) => {
                return (
                  <RecordBlock key={elem.id}>
                    <RecordTitle>
                      <RecordSvg />
                      Message {elem.id}
                    </RecordTitle>
                    <RecordDesc>{parse(elem.text)}</RecordDesc>
                  </RecordBlock>
                );
              })}
            </RecordsContainer>
          </Records>
          <Records>
            <TitleGlobal>Records</TitleGlobal>
            <RecordsContainer>
              {records.map((elem) => {
                return (
                  <RecordBlock key={elem.id}>
                    <RecordTitle>
                      <RecordSvg />
                      Record {elem.id}
                    </RecordTitle>
                    <RecordDesc>{elem.text}</RecordDesc>
                  </RecordBlock>
                );
              })}
            </RecordsContainer>
          </Records>
        </RightContent>
      </Container>
    </DefaultLayout>
  );
}
